import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks a request that must go out without the member's access token.
 *
 * HttpInterceptorService attaches `Authorization: Bearer …` to every request once a
 * member is logged in, which is fine while every call goes to our own APIs. It stops
 * being fine the moment a request targets a different host — the token would travel to
 * a third party that has no business holding it. Requests to foreign origins opt out
 * with this token.
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

/** Convenience for `{ context: skipAuth() }` on an HttpClient call. */
export function skipAuth(): HttpContext {
  return new HttpContext().set(SKIP_AUTH, true);
}
